export type ReportDateRange = {
  date_from: string;
  date_to: string;
};

function formatLocalDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function defaultReportDateRange(): ReportDateRange {
  const today = new Date();
  const start = new Date(today);
  start.setDate(today.getDate() - 30);

  return {
    date_from: formatLocalDate(start),
    date_to: formatLocalDate(today),
  };
}
